<template>
	<div>
		<Modal
			v-if="showTokenExpired"
			:maxWidth="640"
			@close="toggle({ showTokenExpired: false })"
		>
			<div class="login-modal login-modal__token">
				<h4>{{ $t('login.youLoggedOut') }}</h4>
				<br />
				<Button
					@click.native="
						() => {
							toggle({ showLoginForm: true, showTokenExpired: false })
						}
					"
				>
					{{ $t('login.loginAgain') }}
				</Button>
			</div>
		</Modal>
		<Modal
			v-if="showLoginForm"
			:maxWidth="400"
			@close="toggle({ showLoginForm: false })"
		>
			<div class="login-modal login-modal__login">
				<Login_Form
					modal
					:modalStyling="true"
					@close="toggle({ showLoginForm: false, showTokenExpired: false })"
				/>
			</div>
		</Modal>
	</div>
</template>

<script>
import Modal from '../molecules/Modal'
import Button from '../atoms/Button'
import Login_Form from './forms/Login_Form'
import store from '../../vueX/store'

export default {
	name: 'LoginModal',
	components: {
		Modal,
		Button,
		Login_Form
	},
	data() {
		return {}
	},
	computed: {
		showTokenExpired: function () {
			return store.state.globalModals.showTokenExpired
		},
		showLoginForm: function () {
			if (
				this.$route.name === 'resetpassword' ||
				this.$route.name === 'login' ||
				this.$route.name === 'newaccount'
			) {
				return false
			} else {
				return store.state.globalModals.showLoginForm
			}
		}
	},
	methods: {
		toggle(type) {
			store.dispatch('TOGGLE_GLOBAL_MODAL', type)
		}
	},
	created() {}
}
</script>

<style scoped lang="scss">
.login-modal {
	margin-top: 30px;
	text-align: center;

	&__token {
		width: 100%;
	}
}
</style>
